import React from 'react';
import { BackLink } from '../Navigation/BackLink';

interface EntityEditLayoutProps {
  backTo: string;
  backLabel: string;
  title: string;
  subtitle?: string;
  isLoading?: boolean;
  loadingText?: string;
  titleClassName?: string;
  children: React.ReactNode;
}

export const EntityEditLayout: React.FC<EntityEditLayoutProps> = ({
  backTo,
  backLabel,
  title,
  subtitle,
  isLoading = false,
  loadingText = 'Loading...',
  titleClassName = 'text-neutral-900',
  children,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-gray-500">{loadingText}</div>
      </div>
    );
  }

  return (
    <div>
      <BackLink to={backTo} label={backLabel} />
      <div className="mb-6">
        <h1 className={titleClassName}>{title}</h1>
        {subtitle && <p className="text-neutral-600 mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
};

export default EntityEditLayout;
